import { render, staticRenderFns } from "./StationSelect.vue?vue&type=template&id=08b45d2a&scoped=true&"
import script from "./StationSelect.vue?vue&type=script&lang=js&"
export * from "./StationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b45d2a",
  null
  
)

export default component.exports